module.exports = __webpack_public_path__ + "img/money-matters-1173114-639x426.827d7608.png";